import {FAILURE, PENDING, SUCCESS} from '../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}
const InitialState = {
  data: null,
  error: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        data: action.payload.data,
      }
    case FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

const useGetReservationItemDetails = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useGetReservationItemDetails
export {ActionTypes, InitialState, Reducer}
